import { CommodityFilterInput, CommodityStats } from '@bechtel/types';
import { useLazyQuery, QueryTuple } from '@apollo/client';
import { GET_ASSIGN_TO_ME_STATS_FWE } from '@bechtel/client-gql';

export function useAssignToMeStatsFWEQuery(
  fetchFromNetwork?: boolean
): QueryTuple<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }> {
  const response = useLazyQuery<{ commodityStats: CommodityStats }, { input: CommodityFilterInput }>(
    GET_ASSIGN_TO_ME_STATS_FWE,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'no-cache',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
